import React, { useState, useMemo, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  ListGroup,
  Spinner,
  Tabs,
  Tab,
} from "react-bootstrap";
import { getUserList, PatientList } from "../../api/apiHandler";
import EnroleNewPatient from "../../pages/common/FaceAuthentication/EnroleNewPatient";
import FaceDetect from "../../pages/common/FaceAuthentication/FaceDetect";

const PatientNameModal = ({
  setPatientName,
  patientName,
  setShowIsNameModal,
  showIsNameModal,
  handleSave,
  from,
  inviteType,
  selectedRole,
  setSelectedRole,
}) => {
  const [search, setSearch] = useState("");
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("search");

  const filteredPatients = useMemo(() => {
    const query = search.toLowerCase();
    return patients.filter((p) => {
      const fullName = `${p.first_name || ""} ${
        p.last_name || ""
      }`.toLowerCase();
      return (
        fullName.includes(query) ||
        (p.email?.toLowerCase().includes(query) ?? false)
      );
    });
  }, [search, patients]);

  const handleSelect = (p) => {
    const fullName = `${p.first_name || ""} ${p.last_name || ""}`.trim();
    console.log(fullName, "fullNamessss13");

    setPatientName(p);
    setSearch(fullName);
    setLoading(false);
  };

  const fetchPatientList = async (searchValue) => {
    setLoading(true);
    try {
      let response;
      if (inviteType === "invite_users") {
        response = await getUserList({
          page: 1,
          record_count: 10,
          search_text: searchValue,
          roles: [selectedRole?.id],
        });
      } else {
        response = await PatientList({
          search_text: searchValue,
          search_by: "email",
        });
      }

      const parsed = JSON.parse(response);
      console.log(parsed, "parsesearchd");

      if (parsed.code === 200) {
        setPatients(
          parsed?.data?.data ? parsed?.data?.data : parsed?.data?.list || []
        );
      } else {
        console.warn("Unexpected response code:", parsed.id);
        setPatients([]);
      }
    } catch (err) {
      console.error("Failed to fetch patients:", err);
      setPatients([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (search && activeTab === "search") fetchPatientList(search);
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [search, activeTab]);
  const [continueByFace, setContinueByFace] = useState(false);
  return (
    <Modal
      show={showIsNameModal}
      onHide={() => {
        setShowIsNameModal(false);
        setSelectedRole(null);
      }}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="border-0">
        {activeTab === "search" ? (
          <Modal.Title>
            Select{" "}
            {selectedRole?.label === "Chemist"
              ? "Chemist"
              : selectedRole?.label === "Doctor"
              ? "Doctor"
              : "Patient"}
          </Modal.Title>
        ) : (
          <div className="text-center mb-4">
            <h4 className="fw-bold">Enroll New Patient</h4>
          </div>
        )}
      </Modal.Header>

      <Modal.Body>
        <Tabs
          id="patient-tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          {/* Tab 1: Search */}

          <Tab
            eventKey="search"
            title={`Search  ${
              selectedRole?.label === "Chemist"
                ? "Chemist"
                : selectedRole?.label === "Doctor"
                ? "Doctor"
                : "Patient"
            }`}
          >
            {continueByFace ? (
              <>
                <FaceDetect
                  handleSave={handleSave}
                  setPatientName={setPatientName}
                  setShowIsNameModal={setShowIsNameModal}
                  setContinueByFace={setContinueByFace}
                />
              </>
            ) : (
              <Form>
                <Form.Group controlId="patientSearchInput">
                  <Form.Label>Search by name or email</Form.Label>
                  <Form.Control
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    autoFocus
                    placeholder="Search by name or email"
                  />
                </Form.Group>

                {loading && (
                  <div className="d-flex align-items-center gap-2 mt-2">
                    <Spinner animation="border" role="status" size="sm" />
                    <span>Loading...</span>
                  </div>
                )}

                {filteredPatients.length > 0 && (
                  <ListGroup
                    className="mt-3"
                    style={{ maxHeight: 200, overflowY: "auto" }}
                  >
                    {filteredPatients.map((p) => {
                      const fullName = `${p.first_name || ""} ${
                        p.last_name || ""
                      }`.trim();
                      return (
                        <ListGroup.Item
                          key={p.id}
                          action
                          onClick={(e) => {
                            e.preventDefault();
                            handleSelect(p);
                          }}
                        >
                          <div>
                            <strong>{fullName || "Unnamed"}</strong>
                            <div className="text-muted">
                              {p.email || "No email"}
                            </div>
                          </div>
                        </ListGroup.Item>
                      );
                    })}
                  </ListGroup>
                )}
                {from !== "MeadicalCommunity" && (
                  <p
                    className="mb-0 text-primary text-decoration-underline font_12 cursor-pointer"
                    onClick={() => setContinueByFace(true)}
                    style={{ cursor: "pointer" }}
                  >
                    Or Proceed With Face{" "}
                  </p>
                )}
              </Form>
            )}
          </Tab>

          {/* Tab 2: Manual Entry */}
          {from !== "MeadicalCommunity" && (
            <Tab eventKey="manual" title="Enroll">
              <EnroleNewPatient
                handleSave={handleSave}
                setPatientName={setPatientName}
                setShowIsNameModal={setShowIsNameModal}
              />
            </Tab>
          )}
        </Tabs>
      </Modal.Body>

      {activeTab === "search" && continueByFace === false && (
        <Modal.Footer>
          <Button
            disabled={!patientName}
            className="submit-btn font_18"
            onClick={() => handleSave(patientName)}
          >
            Proceed
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default PatientNameModal;
